import { connect } from 'react-redux'
import ContributionForm from './contribution-form'
import {
  getSubmitContributionRequest,
  getCurrentConclusion,
  getAreTemplatesVisible,
  getAreWorksVisible
} from '../../../stores/discussion/discussion.selectors'
import {
  getAssessmentFileConclusionState,
  getAssessmentFileClosedState
} from '../../../stores/assessment-file/assessment-file.selectors'
import {
  submitContribution,
  showTemplates,
  hideTemplates,
  showWorks,
  hideWorks
} from '../../../stores/discussion/discussion.actions'
import { getWorksList } from '../../../stores/works/works.selectors'
import { withRouter } from 'react-router-dom'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { match }) => {
  const currentConclusion = getCurrentConclusion(state)
  return {
    id: match.params.assessmentFileId,
    posting: getSubmitContributionRequest(state).pending,
    currentConclusion: currentConclusion && currentConclusion.id,
    isConcluded: getAssessmentFileConclusionState(state),
    isClosed: getAssessmentFileClosedState(state),
    areTemplatesVisible: getAreTemplatesVisible(state),
    areWorksVisible: getAreWorksVisible(state),
    works: getWorksList(state)
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onShowTemplates: () => {
    dispatch(hideWorks())
    return dispatch(showTemplates())
  },
  onHideTemplates: () => dispatch(hideTemplates()),
  onShowWorks: () => {
    dispatch(hideTemplates())
    return dispatch(showWorks())
  },
  onHideWorks: () => dispatch(hideWorks()),

  onSubmit: values => {
    const data = {
      content: values.contribution,
      file: values.file,
      work_ids: values.workIds
    }
    dispatch(hideWorks())
    dispatch(hideTemplates())
    dispatch(
      submitContribution(stateProps.id, stateProps.currentConclusion, data)
    ).catch(errorHandler)
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContributionForm)
)
